"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventVoiceActor = void 0;
var ProducerEventVoiceActor;
(function (ProducerEventVoiceActor) {
    ProducerEventVoiceActor["enUSAriaNeural"] = "en-US-AriaNeural";
    ProducerEventVoiceActor["enUSGuyNeural"] = "en-US-GuyNeural";
    ProducerEventVoiceActor["enDavisNeural"] = "en-US-DavisNeural";
    ProducerEventVoiceActor["enKaiNeural"] = "en-US-KaiNeural";
    ProducerEventVoiceActor["enLunaNeural"] = "en-US-LunaNeural";
    ProducerEventVoiceActor["enAmandaMultilingualNeural"] = "en-US-AmandaMultilingualNeural";
    ProducerEventVoiceActor["enGBMiaNeural"] = "en-GB-MiaNeural";
    ProducerEventVoiceActor["enGBRyanNeural"] = "en-GB-RyanNeural";
    ProducerEventVoiceActor["enIEEmilyNeural"] = "en-IE-EmilyNeural";
    ProducerEventVoiceActor["enIEConnorNeural"] = "en-IE-ConnorNeural";
    ProducerEventVoiceActor["esESElviraNeural"] = "es-ES-ElviraNeural";
    ProducerEventVoiceActor["esESAlvaroNeural"] = "es-ES-AlvaroNeural";
    ProducerEventVoiceActor["gaIEOrlaNeural"] = "ga-IE-OrlaNeural";
    ProducerEventVoiceActor["gaIEColmNeural"] = "ga-IE-ColmNeural";
    ProducerEventVoiceActor["frCASylvieNeural"] = "fr-CA-SylvieNeural";
    ProducerEventVoiceActor["frCAAntoineNeural"] = "fr-CA-AntoineNeural";
    ProducerEventVoiceActor["svSESofieNeural"] = "sv-SE-SofieNeural";
    ProducerEventVoiceActor["svSEMattiasNeural"] = "sv-SE-MattiasNeural";
})(ProducerEventVoiceActor = exports.ProducerEventVoiceActor || (exports.ProducerEventVoiceActor = {}));
//# sourceMappingURL=producer-event-voice-actor.js.map